goog.provide("shadow.js.shim.module$src$svg$type$adset_channel$video_svg");
goog.provide("module$shadow_js_shim_module$src$svg$type$adset_channel$video_svg");
shadow.js.shim.module$src$svg$type$adset_channel$video_svg = shadow.js.nativeProvides["src/svg/type/adset_channel/video.svg"] = shadow$bridge("src/svg/type/adset_channel/video.svg");
module$shadow_js_shim_module$src$svg$type$adset_channel$video_svg.default = shadow.js.shim.module$src$svg$type$adset_channel$video_svg;
